import { useContext } from "react";
import TranslatationContext from "../contexts/translation";

export const useTranslationContext = () => useContext(TranslatationContext);
